import Repository from "../Repository";

const resource = "/agencies";
export default {
  // Gets agencies settings
  async get() {
    const { data } = await Repository.get(`${resource}`);
    return data;
  }
};
